import { SignUpForm } from '@obvio/template'
import { Stack } from '@obvio/ui'

import { SignTitle } from './SignComponents'

import type { ReactElement } from 'react'

export function SignUpPage(): ReactElement {
  return (
    <Stack kind="vertical">
      <SignTitle
        title="Zarejestruj się"
        description="Podaj swój e-mail i hasło, aby kontynuować"
      />
      <SignUpForm submitProps={{ kind: 'ghost' }} />
    </Stack>
  )
}
